import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconWorkspace = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 25"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M.75 14.792c0-.54.438-.978.978-.978h20.544c.54 0 .978.438.978.978v8.479c0 .54-.438.978-.978.978H1.728a.978.978 0 01-.978-.978v-8.479z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M2.25 13.814V7.977A.983.983 0 013.237 7h8.388c.31 0 .602.145.789.392L13.6 9.248h6.414a.983.983 0 01.986.979v3.587M9.065 16.748h5.87M19.737 6.248v-1.27A.983.983 0 0018.75 4H13.6l-1.186-1.86a.987.987 0 00-.79-.392H4.5a.983.983 0 00-.987.98V3.77",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconWorkspace.displayName = "IconWorkspace";

export { IconWorkspace };
